import(/* webpackMode: "eager" */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
import(/* webpackMode: "eager" */ "/app/src/views/terms/en.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/terms/es.tsx");
import(/* webpackMode: "eager" */ "/app/src/views/terms/pt.tsx")